function Navbar() {
  return (
    <nav className="navigation">
      <div className="nav-links">
        <a href="#countdown">Countdown</a>
        <a href="#pictures">Pictures</a>
        <a href="https://fivehillsrealty.guestybookings.com/en/properties/67cdea3318e11c0012191190">Listing</a>
        <a href="https://youtu.be/aAU0qq-DHy0">Video</a>
        <a href="https://docs.google.com/spreadsheets/d/1T4-c3Nx7EsRznH-0KWbGfLqlACIm09xlq8MkNeqqHjQ/edit?usp=sharing" target="_blank" rel="noopener noreferrer">Planning</a>
      </div>
    </nav>
  );
}

export default Navbar;
